// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5jhTL","navBlock":"styles_navBlock__IjdzO","social":"styles_social__nND4m"};